<div
  class="file-uploader"
  *ngIf="platformControl.value === 'google' && authMethodControl.value === AuthenticationMethods.serviceAccount"
>
  <div class="file-uploader-key">
    {{ 'integrationPage.authDetails.serviceAccountPrivateKeyDetailsFieldKey' | labelsProvider }}
  </div>
  <div class="file-uploader-description">
    {{ 'integrationPage.authDescriptions.googleServiceAccountPrivateKeyDetails' | labelsProvider }}
  </div>
  <input
    id="#ServiceAccountJsonHiddenFileUploader"
    type="file"
    multiple
    (change)="onsServiceAccountJsonFileSelected($event)"
    hidden="true"
  />
  <div class="file-uploader-button" (click)="openFileSelectionDialog()">
    <img src="assets/images/common/import.svg" />
    <span>
      {{ 'common.uploadFile' | labelsProvider }}
    </span>
  </div>
  <div class="file-uploader-error" *ngIf="fileWarningMessage() !== ''">
    <span>
      {{ fileWarningMessage() }}
    </span>
  </div>
</div>

<div class="credentials-details-container" *ngIf="platformControl.value && authMethodControl.value">
  <div *ngFor="let credential of credentialsDetails" class="detail-keyvalue">
    <app-detail-keyvalue
      [input]="credential"
      [placeholder]="!isInAddMode && !authMethodHadChanged && credential.isSensitive ? MOCK_SECRET_TEXT : ''"
    >
    </app-detail-keyvalue>
  </div>
</div>

<div class="oauth-method" *ngIf="authMethodControl.value === AuthenticationMethods.oauthAuthorizationCode">
  <img
    src="{{ svgSignInPath }}"
    class="sign-in-button"
    (click)="signInUsingOauth()"
    [ngClass]="{
      'sign-in-button-disabled':
        (this.platformControl.value === 'service_now' &&
          (this.credentialsFormGroup.controls['service-now-instance-url'].valid === false ||
            this.credentialsFormGroup.controls['client-id'].valid === false)) ||
        userTryingToSignInUsingOauth ||
        userSignedInUsingOauth,
      'sign-in-button-required': formSubmitAttempt && !userSignedInUsingOauth && shouldUpdateCredentials,
    }"
  />
  <img *ngIf="userSignedInUsingOauth" class="successful-sign-in-v" src="assets/images/common/check.svg" />
</div>
